module.exports = __webpack_public_path__ + "img/logo.78981c24.png";